module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("7VG2F"))).then(() => parcelRequire('5erN3'));